// extracted by mini-css-extract-plugin
module.exports = {"controls__button":"controls__button-gpLyi","single":"single-3UOLd","controls":"controls-2gCwe","back":"back-1FFjX"};